import moment from 'moment'

export const getTimeZone = () => {
  var offset = new Date().getTimezoneOffset(),
    o = Math.abs(offset)
  const timeZone =
    (offset < 0 ? '+' : '-') +
    ('00' + Math.floor(o / 60)).slice(-2) +
    ':' +
    ('00' + (o % 60)).slice(-2)
  const timeZoneToInteger = parseFloat(timeZone.replace(':', ''))
  return timeZoneToInteger
}

export const getDateAndTime = (date: string) => {
  if (
    !date ||
    date === '0001-01-01T00:00:00' ||
    date === '0001-01-01T00:00:00Z' ||
    date === '0001-01-01T00:00:00.000Z'
  )
    return '-'
  /* return `${format(new Date(date), 'MM/dd/yyyy')} ${format(new Date(date), 'HH:mm')}`; */
  return moment(date).utc().format('MM/DD/YYYY HH:mm')
}

export const getDate = (date: string) => {
  if (
    !date ||
    date === '0001-01-01T00:00:00' ||
    date === '0001-01-01T00:00:00Z' ||
    date === '0001-01-01T00:00:00.000Z'
  )
    return '-'
  /* return `${format(new Date(date), 'MM/dd/yyyy')}`; */
  return moment(date).utc().format('MM/DD/YYYY')
}

export const getDateForChart = (date: string) => {
  if (
    !date ||
    date === '0001-01-01T00:00:00' ||
    date === '0001-01-01T00:00:00Z' ||
    date === '0001-01-01T00:00:00.000Z'
  )
    return '-'
  return moment(date).utc().format('DD MMM')
}

export const getTime = (date: string) => {
  if (
    !date ||
    date === '0001-01-01T00:00:00' ||
    date === '0001-01-01T00:00:00Z' ||
    date === '0001-01-01T00:00:00.000Z'
  )
    return '-'
  /* return `${format(new Date(date), 'HH:mm')}`; */
  return moment(date).utc().format('HH:mm')
}

export const getTimeforDate = (date: Date | string) => {
  // if date for string return string else return date
  if (typeof date === 'string') {
    return date
  }
  /* return `${format(new Date(date), 'HH:mm')}`; */
  return moment(date).utc().format('HH:mm')
}
